import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CalendarSettingsResponse,
  CalendarSettingsTabBarType,
} from "../../types/calendarSettings";
import { getCalendarSettings } from "./action";

type CalendarSettingsSlice = {
  selectedCalendarSettingsTab: CalendarSettingsTabBarType;
  calendarSettingsData?: CalendarSettingsResponse;
  error?: string;
  loading: boolean;
};

const initialState: CalendarSettingsSlice = {
  selectedCalendarSettingsTab: "General",
  loading: false,
};

const calendarSettingsSlice = createSlice({
  name: "calendar-settings",
  initialState,
  reducers: {
    setSelectedCalendarSettingsTab(
      state,
      action: PayloadAction<CalendarSettingsTabBarType>,
    ) {
      state.selectedCalendarSettingsTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCalendarSettings.pending, (state) => {
        state.loading = true;
        delete state.error;
      })
      .addCase(
        getCalendarSettings.fulfilled,
        (state, action: PayloadAction<CalendarSettingsResponse>) => {
          state.calendarSettingsData = action.payload;
          state.loading = false;
        },
      )
      .addCase(getCalendarSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setSelectedCalendarSettingsTab } = calendarSettingsSlice.actions;
export default calendarSettingsSlice.reducer;
